import classNames from 'classnames';
import { memo } from 'react';
import { Text } from '../text/text.component';
import './count.component.scss';
import { getCSS } from '@gimlite/common';

const variantMapper = {
  light: {
    default: {
      backgroundColor: 'deep_indigo_10',
      color: 'deep_indigo_70',
    },
    selected: {
      backgroundColor: 'deep_indigo_4',
      color: 'deep_indigo',
    },
  },
  dark: {
    default: {
      backgroundColor: 'deep_indigo',
      color: 'deep_indigo_4',
    },
    selected: {
      color: 'deep_indigo',
      backgroundColor: 'deep_indigo_4',
    },
  },
} as const satisfies Record<
  string,
  {
    default: { backgroundColor: string; color: string };
    selected: { backgroundColor: string; color: string };
  }
>;

export declare namespace CountType {
  type Props = {
    className?: string | null;
    children: React.ReactNode | null;
    disabled?: boolean | null;
    selected?: boolean | null;
    variant?: keyof typeof variantMapper;
  };
}

export const Count = memo(
  ({
    className,
    children,
    disabled,
    selected,
    variant = 'light',
  }: CountType.Props) => {
    const currentVariant = variantMapper[variant];

    return (
      <div
        className={classNames(
          'count',
          {
            'count--disabled': disabled,
          },
          className,
        )}
        style={{
          backgroundColor: selected
            ? getCSS(`--color-${currentVariant.selected.backgroundColor}`)
            : getCSS(`--color-${currentVariant.default.backgroundColor}`),
        }}
      >
        <Text
          variant="subhead"
          color={
            selected
              ? currentVariant.selected.color
              : currentVariant.default.color
          }
        >
          {children}
        </Text>
      </div>
    );
  },
);
